import React from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './App';
const vf = document.getElementById('validation-flow');
if (vf) {
  const root = createRoot(document.getElementById('validation-flow'));
  const dataSet = vf.dataset;
  root.render(<App vf={dataSet}/>);
}
